import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { updateSystem } from '../../../api/system';

const useUpdateSystem = (options?: Omit<UseMutationOptions, 'mutationFn'>) => {
  return useMutation({
    mutationFn: updateSystem,
    ...options,
  });
};

export default useUpdateSystem;
